import { LocalDate, YearMonth, LocalTime, ZonedTime } from './types';

const pad = (n: number): string => String(n).padStart(2, '0');

const parse = (d: LocalDate): { year: number, month: number, day: number } => {
  const [ year, month, day ] = d.split('-').map(Number);
  return { year, month, day };
};

const format = (year: number, month: number, day: number): LocalDate =>
  `${year}-${pad(month)}-${pad(day)}` as LocalDate;

const toUtcMs = (d: LocalDate): number => {
  const { year, month, day } = parse(d);
  return Date.UTC(year, month - 1, day);
};

const addDays = (d: LocalDate, n: number): LocalDate => {
  const date = new Date(toUtcMs(d));
  date.setUTCDate(date.getUTCDate() + n);
  return format(date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate());
};

// Desplaza n meses y recorta al último día del mes destino si el día de
// origen no existe ahí (31 mar −1m → 28/29 feb).
const addMonthsClamped = (d: LocalDate, n: number): LocalDate => {
  const { year, month, day } = parse(d);
  const totalMonths = year * 12 + (month - 1) + n;
  const targetYear = Math.floor(totalMonths / 12);
  const targetMonth = totalMonths - targetYear * 12 + 1; // 1-indexado
  const lastDayOfTargetMonth = new Date(Date.UTC(targetYear, targetMonth, 0)).getUTCDate();
  return format(targetYear, targetMonth, Math.min(day, lastDayOfTargetMonth));
};

const daysBetween = (a: LocalDate, b: LocalDate): number =>
  Math.round((toUtcMs(b) - toUtcMs(a)) / 86400000);

const monthOf = (d: LocalDate): YearMonth => {
  const { year, month } = parse(d);
  return `${year}-${pad(month)}` as YearMonth;
};

// Solo horas completas — ver §05: precisión de minuto rompe el cacheo.
const startOfHour = (now: ZonedTime): LocalTime =>
  `${pad(now.hour)}:00` as LocalTime;

// Desplaza un YearMonth ±n meses. Sin día de mes que recortar, así que es
// addMonthsClamped anclado al día 1.
const shiftYearMonth = (ym: YearMonth, n: number): YearMonth =>
  monthOf(addMonthsClamped(`${ym}-01` as LocalDate, n));

const lastDayOfMonth = (ym: YearMonth): LocalDate =>
  addDays(`${shiftYearMonth(ym, 1)}-01` as LocalDate, -1);

export { addDays, addMonthsClamped, daysBetween, monthOf, startOfHour, shiftYearMonth, lastDayOfMonth };
